import { authenticatedAjax, REQUEST } from "../../../../config/ajax-wrapper";
import { AnyAction } from "redux";
import fileDownload from "js-file-download";
import {
    ENVIAR_SAT_RETIRO,
    ENVIAR_SAT_MASIVO_RETIRO,
    ERROR_AUTORIZACION,
    ERROR_ENVIO_RETIRO_INDIVIDUAL,
    ERROR_ENVIO_RETIRO_MASIVO,
    ENVIO_EXITOSO_RETIRO,
    ENVIO_EXITOSO_RETIRO_MASIVO,
    DESCARGAR_PLANTILLA_MASIVO_RETIRO,
    PLANTILLA_RETIRO_OBTENIDA,
    ERROR_OBTENIENDO_PLANTILLA_RETIRO,
    LIMPIAR_MENSAJES_RETIRO,
    errorAutorizacion,
    errorEnvioRetiroIndividual,
    errorEnvioRetiroMasivo,
    envioRetiroExito,
    envioRetiroMasivoExito,
    plantillaRetiroObtenida,
    errorObteniendoPlantillaRetiro
} from "../modulos/procesarRetiroActions";

export const enviarSATRetiroEpic = action$ =>
    action$.ofType(ENVIAR_SAT_RETIRO)
        .mergeMap((action: any) => {

            const url = `sat/retiro-definitivo/envio-individual`;

            return authenticatedAjax
                .post(
                    url,
                    action.datosEnvioRetiro,
                    { 'Content-Type': 'application/json', 'proceso': 'RETIRO_DEFINITIVO' }
                )
                .map(response => {
                    const respuesta = response.response.datos;
                    return envioRetiroExito(respuesta.poliza, respuesta.dni);
                }).catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion()];
                    } else {
                        const respuesta = response.response;
                        const mensajeRespuesta = (response.response && respuesta.mensajeRespuesta) ? respuesta.mensajeRespuesta : "Error no controlado en la aplicación";
                        return [errorEnvioRetiroIndividual(mensajeRespuesta)];
                    }
                });
        });

export const enviarSATMasivoRetiroEpic = action$ =>
    action$.ofType(ENVIAR_SAT_MASIVO_RETIRO)
        .mergeMap((action: any) => {

            const url = `sat/retiro-definitivo/envio-masivo`;

            return authenticatedAjax
                .upload(
                    url,
                    action.archivoEnvioRetiro, {}, { 'proceso': 'RETIRO_DEFINITIVO' }
                )
                .map((response) => {
                    return envioRetiroMasivoExito();
                }).catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion()];
                    } else {
                        const respuesta = response.response;
                        const mensajeRespuesta = (response.response && respuesta.mensajeRespuesta) ? respuesta.mensajeRespuesta : "Error no controlado en la aplicación";
                        return [errorEnvioRetiroMasivo(mensajeRespuesta)];
                    }
                });
        });

export const descargarPlantillaMasivoRetiroEpic = action$ =>
    action$.ofType(DESCARGAR_PLANTILLA_MASIVO_RETIRO)
        .mergeMap((action: any) => {

            const url = `sat/descargas/plantilla-retiro`;

            return authenticatedAjax
                .getBlob(url)
                .map((response) => {
                    const data = response.response;
                    fileDownload(
                        data,
                        "plantilla_masivo_retiro_definitivo.xlsx",
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    );
                    return plantillaRetiroObtenida();
                }).catch(response =>
                    [errorObteniendoPlantillaRetiro()]
                );
        });

export const envioRetirosReducer = (state =
    {
        estadoEnvio: REQUEST.NONE,
        mensajeUsuario: undefined,
        poliza: undefined,
        dni: undefined
    }, action: AnyAction) => {

    switch (action.type) {

        case ENVIAR_SAT_RETIRO:
            return {
                ...state,
                estadoEnvioIndividual: REQUEST.PENDING,
                estadoEnvioMasivo: REQUEST.NONE
            };
        case ENVIAR_SAT_MASIVO_RETIRO:
            return {
                ...state,
                estadoEnvioIndividual: REQUEST.NONE,
                estadoEnvioMasivo: REQUEST.PENDING
            };
        case ENVIO_EXITOSO_RETIRO:
            return {
                ...state,
                estadoEnvioIndividual: REQUEST.SUCCESS,
                estadoEnvioMasivo: REQUEST.NONE,
                poliza: action.poliza,
                dni: action.dni
            };
        case ENVIO_EXITOSO_RETIRO_MASIVO:
            return {
                ...state,
                estadoEnvioMasivo: REQUEST.SUCCESS,
                estadoEnvioIndividual: REQUEST.NONE
            };
        case ERROR_AUTORIZACION:
            return {
                ...state,
                estadoEnvioIndividual: REQUEST.FORBIDDEN,
                estadoEnvioMasivo: REQUEST.FORBIDDEN
            };
        case ERROR_ENVIO_RETIRO_INDIVIDUAL:
            return {
                ...state,
                estadoEnvioIndividual: REQUEST.ERROR,
                mensajeUsuario: action.mensajeRespuesta
            };
        case ERROR_ENVIO_RETIRO_MASIVO:
            return {
                ...state,
                estadoEnvioMasivo: REQUEST.ERROR,
                mensajeUsuario: action.mensajeRespuesta
            };
        case LIMPIAR_MENSAJES_RETIRO:
            return {
                estadoEnvioIndividual: REQUEST.NONE,
                estadoEnvioMasivo: REQUEST.NONE,
                poliza: undefined,
                dni: undefined,
                mensajeUsuario: undefined
            };
        case PLANTILLA_RETIRO_OBTENIDA:
        case ERROR_OBTENIENDO_PLANTILLA_RETIRO:
            return { ...state };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/procesar_retiro/modulos/procesarRetiroReducers.ts